module.exports = __webpack_public_path__ + "static/media/purepaper-metal.238eb7a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brands/purepaper-metal.svg
// module id = 1154
// module chunks = 37